<template>
  <div class="card mb-2" @click="onClick">
    <div class="pt-3 pb-1 text-center card-header">
      <span class="text-uppercase font-weight-bold text-dark overflow-text">
        {{ nps.nome_empresa ?? 'Não informado' }}
      </span>

      <span class="text-sm" style="float: left;">{{ nps.cliente_id_painel ?? 'Não informado' }}</span>
      <span class="text-sm" style="float: right;">{{ formatarDocumento(nps.documento) }}</span>
    </div>
    <div class="pt-1 text-center card-body">
      <div class="opcoes-card d-flex justify-content-between">
        <label>Média Nota</label>
        <h6 class="mb-0 font-weight-bold text-sm" :class="['badge', npsScoreClass]">
          {{ filters.formatNpsNota(nps.media_notas) }}
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label>Respostas</label>
        <h6 class="mb-0 font-weight-bold text-sm">
          <span>{{ nps.respostas }}</span>
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label>Follow-ups</label>
        <h6 class="mb-0 font-weight-bold text-sm">
          <span>{{ nps.follow_ups }}</span>
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label>Data fim NPS</label>
        <h6 class="mb-0 font-weight-bold text-sm">
          {{ formatDate(nps.data_final) || 'Não informado' }}
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label><i class="fas fa-phone me-2"></i>Telefone</label>
        <h6 class="mb-0 font-weight-bold text-sm">
          {{ formatarTelefone(nps.telefone) || 'Não informado' }}
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label><i class="fas fa-mobile-alt me-2"></i>Celular</label>
        <h6 class="mb-0 font-weight-bold text-sm">
          {{ formatarTelefone(nps.celular) || 'Não informado' }}
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label>Plano</label>
        <p class="mb-0 text-sm badge badge-primary">
          {{ nps.plano || 'Sem plano' }}
        </p>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label>Closer</label>
        <h6 class="mb-0 font-weight-bolder text-xs">
          {{ nps.closer_name || 'Não atribuído' }}
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label>Data Contrato</label>
        <h6 class="mb-0 font-weight-bolder text-xs">
          {{ formatDate(nps.data_contrato) || 'Não informado' }}
        </h6>
      </div>
      <div class="opcoes-card d-flex justify-content-between">
        <label>Valor MRR</label>
        <h6 class="mb-0 font-weight-bold text-sm">
          <b>{{ filters.currencyWithPrefix(nps.valor) }}</b>
        </h6>
      </div>

    </div>
  </div>
</template>

<script>
import { formatDocument } from '@/utils/document';

export default {
  name: "NpsCardKanban",
  emits: ['click'],
  props: {
    nps: {
      type: Object,
      required: true,
      default: () => ({})
    },
  },
  computed: {
    npsScoreClass() {
      const score = Number(this.nps.media_notas);
      if (score <= 6) return 'badge-danger';
      return 'badge-success';
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
    formatarDocumento(doc) {
      if (!doc) return 'Não informado';
      return formatDocument(doc);
    },
    formatarTelefone(telefone) {
      if (!telefone) return '';

      // Remove tudo que não for número
      const numero = telefone.replace(/\D/g, '');

      // Verifica se tem a quantidade correta de dígitos
      if (numero.length !== 10 && numero.length !== 11) return telefone;

      // Formata como (00) 00000-0000 ou (00) 0000-0000
      if (numero.length === 11) {
        return `(${numero.slice(0, 2)}) ${numero.slice(2, 7)}-${numero.slice(7)}`;
      } else {
        return `(${numero.slice(0, 2)}) ${numero.slice(2, 6)}-${numero.slice(6)}`;
      }
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return d.toLocaleDateString('pt-BR');
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 0.4px solid #212529;
  cursor: move;

  label {
    margin-bottom: 0 !important;
  }

  .card-body {
    padding: 1rem;

    label {
      text-align: left;
    }
  }

  .overflow-text {
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .comentario {
    max-height: 60px;
    overflow-y: auto;
    white-space: pre-wrap;
  }

  .badge {
    padding: 2px 10px 2px 10px;
    font-size: 0.65rem;
    font-weight: 700;
    border-radius: 0.5rem;

    &.badge-success {
      background-color: #198754;
      color: white;
    }

    &.badge-warning {
      background-color: #ffc107;
      color: black;
    }

    &.badge-danger {
      background-color: #dc3545;
      color: white;
    }
  }
}

.opcoes-card {
  padding: 8px;
  border-top: 0.4px solid #8f9ca88a;
}
</style>
